import { createService } from "../../api/serviceService";

export const useCreateService = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createService(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create service:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};